import React from "react";
import { cn } from "@/lib/utils";
import type { TypingState } from "@/hooks/useTypingEngine";

interface TypingAreaProps {
  snippet: string;
  state: TypingState;
  title: string;
}

export default function TypingArea({ snippet, state, title }: TypingAreaProps) {
  return (
    <div className="w-full">
      <div className="text-sm text-muted-foreground mb-2 font-medium">{title}</div>
      <pre className="bg-card border rounded-lg p-4 font-mono text-base leading-relaxed whitespace-pre-wrap overflow-x-auto">
        {snippet.split("").map((char, i) => {
          const isTyped = i < state.cursorPos;
          const isCursor = i === state.cursorPos;
          const isError = state.errorPositions.has(i);

          let displayChar = char;
          if (char === "\n") displayChar = "↵\n";

          return (
            <span
              key={i}
              className={cn(
                "relative",
                isTyped && !isError && "text-green-500",
                isTyped && isError && "text-red-400 bg-red-500/10",
                isCursor && "bg-primary/20 text-foreground",
                !isTyped && !isCursor && "text-muted-foreground/50",
              )}
            >
              {isCursor && (
                <span className="absolute bottom-0 left-0 w-full h-0.5 bg-primary animate-pulse" />
              )}
              {displayChar}
            </span>
          );
        })}
        {state.isComplete && (
          <span className="text-green-500 font-bold"> ✓</span>
        )}
      </pre>
    </div>
  );
}
